import { Modal } from "../Modal";
import { ModalActionsEnum } from "../../../types/ModalActionsEnum";
import { useState } from "react";
import useDatabase from "../../../hooks/useDatabase";
import Option from "../../../types/Option";

import { ModalCreate } from './ModalCreate'
import { ModalUpdate } from './ModalUpdate'
import { ModalDelete } from './ModalDelete'

export const ModalCrudAnillado = ({
  modalAction,
  setModalAction,
  onConfirm,
  hojas,
}: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { addCollection, updateCollection, deleteCollection } = useDatabase();
  const { collection: collectionProp, item, action } = modalAction;
  const collection = collectionProp ?? item.collection;
  const hojasOptions: Option[] = hojas.map((hoja: any) => ({
    value: hoja.id,
    text: hoja.name,
  }));

  const isCreate = action === ModalActionsEnum.CREATE;
  const isUpdate = action === ModalActionsEnum.UPDATE;
  const isDelete = action === ModalActionsEnum.DELETE;

  const getTitle = () => {
    if (isCreate) return `Nuevo: ${collection}`;
    if (isUpdate) return `Actualizar: ${collection}`;
    if (isDelete) return `Confimación`;

    return "";
  };

  const onCloseModal = () => {
    setModalAction(null);
  };

  const onConfirmCreate = async (itemCreate: any) => {
    setLoading(true);
    const createdItem = await addCollection(collection, itemCreate);
    setLoading(false);

    onConfirm(ModalActionsEnum.CREATE, collection, createdItem);
  };

  const onConfirmUpdate = async (itemUpdate: any) => {
    setLoading(true);
    await updateCollection(collection, itemUpdate);
    setLoading(false);

    onConfirm(ModalActionsEnum.UPDATE, collection, itemUpdate);
  };

  const onConfirmDelete = async (itemDelete: any) => {
    setLoading(true);
    await deleteCollection(collection, itemDelete.id);
    setLoading(false);

    onConfirm(ModalActionsEnum.DELETE, collection, itemDelete);
  };

  return (
    <Modal open={!!modalAction} title={getTitle()} onClose={onCloseModal}>
      {isCreate && (
        <ModalCreate
          loading={loading}
          collection={collection}
          onCancel={onCloseModal}
          onConfirm={onConfirmCreate}
          hojasOptions={hojasOptions}
        />
      )}
      {isUpdate && (
        <ModalUpdate
          loading={loading}
          item={item}
          onCancel={onCloseModal}
          onConfirm={onConfirmUpdate}
          hojasOptions={hojasOptions}
        />
      )}
      {isDelete && (
        <ModalDelete
          loading={loading}
          item={item}
          onCancel={onCloseModal}
          onConfirm={onConfirmDelete}
        />
      )}
    </Modal>
  );
};




